import { render } from "./ModalContentAIGenerate.vue?vue&type=template&id=5bec019d&lang=true"
import script from "./ModalContentAIGenerate.vue?vue&type=script&lang=js"
export * from "./ModalContentAIGenerate.vue?vue&type=script&lang=js"

import "./ModalContentAIGenerate.vue?vue&type=style&index=0&id=5bec019d&lang=css"
script.render = render

export default script